import React from "react";

const SVG = ({
    style = {},
    fill = "#000",
    width = "10px",
    height = "17px",
    className = "",
    viewBox = "0 0 24 24"
}) => (
        <svg
            width={height}
            style={style}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-icon ${className || ""}`}
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill={fill}
                d="M16.3828125,11.9487305 C18.2587891,11.9487305 19.7861328,10.3051758 19.7861328,8.21337891 C19.7861328,6.19628906 18.2421875,4.56933594 16.3828125,4.56933594 C14.5151367,4.56933594 12.9711914,6.21289062 12.9711914,8.22167969 C12.9794922,10.3051758 14.4985352,11.9487305 16.3828125,11.9487305 Z M6.70410156,12.1313477 C8.33935547,12.1313477 9.67578125,10.6953125 9.67578125,8.88574219 C9.67578125,7.11767578 8.33105469,5.70654297 6.70410156,5.70654297 C5.08544922,5.70654297 3.74072266,7.13427734 3.74072266,8.89404297 C3.74902344,10.6953125 5.07714844,12.1313477 6.70410156,12.1313477 Z M8.29785156,19.7431641 C7.36816406,18.4482422 8.16503906,15.9580078 10.1904297,14.3227539 C9.30224609,13.7832031 8.11523438,13.3764648 6.70410156,13.3764648 C3.06835938,13.3764648 0.553222656,16.0493164 0.553222656,18.2158203 C0.553222656,19.1787109 0.9765625,19.7431641 2.22167969,19.7431641 L8.29785156,19.7431641 Z M21.4794922,19.7348633 C22.9570312,19.7348633 23.4467773,19.2451172 23.4467773,18.4150391 C23.4467773,16.2900391 20.6826172,13.3930664 16.3745117,13.3930664 C12.074707,13.3930664 9.31054688,16.2900391 9.31054688,18.4150391 C9.31054688,19.2451172 9.80029297,19.7348633 11.277832,19.7348633 L21.4794922,19.7348633 Z"
            />
        </svg>
    );

export default SVG;
